import { render, staticRenderFns } from "./McColorPicker.vue?vue&type=template&id=d9a0cd66"
import script from "./McColorPicker.vue?vue&type=script&lang=js"
export * from "./McColorPicker.vue?vue&type=script&lang=js"
import style0 from "./McColorPicker.vue?vue&type=style&index=0&id=d9a0cd66&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports